var command = {
  command: 'compile',
  description: 'Compile contract source files',
  builder: {
    all: {
      type: "boolean",
      default: false
    }
  },
  run: function (options, done) {
    var Config = require("truffle-config");
    var Contracts = require("truffle-workflow-compile");

    var config = Config.detect(options);
    Contracts.compile(config, done);
  }
}

module.exports = command;



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-core/lib/commands/compile.js
// module id = 1164
// module chunks = 0